import { pushPromoView, pushPromoClick, pushProductClick, pushProductImpression } from "./utils";

//GLOBAL VARIABLES
const HOMEPAGE_LIST = "Homepage";
const HOMEPAGE_PRODUCT_IMPRESSION = "homepagePoductImpressions";
const HOMEPAGE_SLIDERS_VIEWS = "homepageSliderViews";
const HOMEPAGE_CATEGORIES_VIEW = "homepagecategoriesViews";
const HOMEPAGE_DISCOVER_VIEW = "homepageDiscoverViews";
const HOMEPAGE_SERVICE_VIEW = "homepageServiceViews";

/**
 * Removes \ and /  from image src provided.
 * @param {String} src
 * @returns {String} cleaned string.
 */
const cleanImageSrc = src => {
    if (!src) {
        return "";
    }

    return src.replace(/^.*[\\\/]/, ""); // eslint-disable-line
};


// TOP SLIDES PART - START

/**
 * forms data for one slide necessary for datalayer
 * @param {Object} slide - one top banner slide
 * @returns {Object} the necessary object for data layer
 */
const getSlidePromoView = slide => {
    const slidePromoView = slide?.dataset?.topSliderPromoView;
    const imageName = cleanImageSrc(slide.querySelector("img")?.src).split("?")[0];
    const slideIndex = slide.closest(".experience-commerce_assets-mainBanner").dataset.slickIndex;
    const slidePromoViewObj = JSON.parse(slidePromoView);
    if (slidePromoViewObj) {
        slidePromoViewObj.id = slidePromoViewObj.id + imageName;
        slidePromoViewObj.creative = imageName;
        slidePromoViewObj.position = Number(slideIndex) + 1;
    }

    return slidePromoViewObj;
};

/**
 * inits the home page top sliders data layer promo view
 */
const initHomePageTopSlidersDataLayerPromoView = () => {
    const topSliderPromoViewDetail = [...document.querySelectorAll("[data-top-slider-promo-view]")].map(slide => {
        const closestElement = slide.closest(".experience-commerce_assets-mainBanner");

        if (!closestElement || closestElement.classList.contains("slick-cloned")) {
            return null;
        }

        const topSlideImpression = getSlidePromoView(slide);

        closestElement.addEventListener("click", () => {
            pushPromoClick([topSlideImpression]);
        });

        return topSlideImpression;
    }).filter(slide => {
        return !!slide;
    });

    pushPromoView(topSliderPromoViewDetail, HOMEPAGE_SLIDERS_VIEWS);
};

// TOP SLIDES PART - END

// HOME PAGE PRODUCTS - START

/**
 * inits the home page products data layer view
 */
const pushHomePageProductImpression = () => {

    const homePageProductsImpression = [...document.querySelectorAll(".pd-tile-wrap")].map(item => {
        if (item.classList.contains("slick-cloned")) {
            return null;
        }
        const idx = item.dataset.idx;
        const productTileImpression = JSON.parse(item.querySelector(".ct-product-tile").dataset?.productTileImpression);

        const homePageProductImpression = Object.assign({}, productTileImpression, {
            "list": HOMEPAGE_LIST,
            "position": idx
        });

        const clickImpression = Object.assign({}, productTileImpression, {
            "position": idx
        });

        const descriptionElement = item.querySelector(".pwc-tile--description");
        if (descriptionElement) {
            descriptionElement.addEventListener("click", () => {
                pushProductClick([clickImpression], HOMEPAGE_LIST);
            });
        }

        const tileImageElement = item.querySelector(".ct-tile-image");
        if (tileImageElement) {
            tileImageElement.addEventListener("click", () => {
                pushProductClick([clickImpression], HOMEPAGE_LIST);
            });
        }

        return homePageProductImpression;
    }).filter(item => {

        return !!item;
    });

    pushProductImpression(homePageProductsImpression, HOMEPAGE_PRODUCT_IMPRESSION);
};

// HOME PAGE HIGHLIGHTED CATEGORIES - START

/**
 * forms data for one highlighted category necessary for datalayer
 * @param {Object} item - one highlighted category item
 * @param {String} index - category index
 * @returns {Object} the necessary object for data layer
 */
const getHomePageCategoryData = (item, index) =>{
    const categoryImage = item.querySelector("img");
    const categoryImageName = cleanImageSrc(categoryImage?.dataset?.src).split("?")[0];
    const categoryData = Object.assign({}, {
        "id": "homepage-category-" + categoryImageName,
        "name": categoryImage?.alt,
        "creative": categoryImageName,
        "position": index + 1
    });

    return categoryData;
};

/**
 * inits the home page highlighted categories data layer view
 */
const pushHomePageCategoriesImpression = () => {
    const homePageCategoriesImpression = [...document.querySelectorAll(".category-tile-wrapper")].map((item, index) => {
        const homePageCategoryImpression = getHomePageCategoryData(item, index);
        item.addEventListener("click", () => {
            pushPromoClick([homePageCategoryImpression]);
        });

        return homePageCategoryImpression;
    }).filter(item => {

        return !!item;
    });

    pushPromoView(homePageCategoriesImpression, HOMEPAGE_CATEGORIES_VIEW);
};

// HOME PAGE HIGHLIGHTED CATEGORIES - END

// HOME PAGE Discover in our store & Services - START

/**
 * forms data for one discovery or service item necessary for datalayer
 * @param {Object} item - one custom discovery or service item
 * @returns {Object} the necessary object for data layer
 */
const getDiscoverAndServiceData = (item, index, string) => {
    const image = item.querySelector("img");
    const imageName = cleanImageSrc(image?.dataset?.src).split("?")[0];
    const data = Object.assign({}, {
        "id": string + imageName,
        "name": image?.alt,
        "creative": imageName,
        "position": index + 1
    });

    return data;
};

/**
 * inits the home page discovery and service data layer view
 */
const pushHomeDiscoverandDiscoverImpression = () => {
    const homePageDiscover = "homepage-discover-";
    const homePageService = "homepage-service-";

    const homePageDiscoverImpression = [...document.querySelectorAll(".news-tile-wrapper")].map((item, index) => {
        const discoverImpression = getDiscoverAndServiceData(item, index, homePageDiscover);
        item.addEventListener("click", () => {
            pushPromoClick([discoverImpression]);
        });

        return discoverImpression;
    }).filter(item => {

        return !!item;
    });

    const homePageServiceImpression = [...document.querySelectorAll(".experience-commerce_assets-imageTextAndButton"), ...document.querySelectorAll(".experience-commerce_assets-imageTextAndLink")].map((item, index) => {
        const serviceImpression = getDiscoverAndServiceData(item, index, homePageService);

        item.addEventListener("click", () => {
            pushPromoClick([serviceImpression]);
        });

        return serviceImpression;
    }).filter(item => {

        return !!item;
    });

    pushPromoView(homePageServiceImpression, HOMEPAGE_SERVICE_VIEW);

    pushPromoView(homePageDiscoverImpression, HOMEPAGE_DISCOVER_VIEW);
};

// HOME PAGE Discover in our store & Services - END


const initDataLayer = () => {
    initHomePageTopSlidersDataLayerPromoView();
    pushHomePageProductImpression();
    pushHomePageCategoriesImpression();
    pushHomeDiscoverandDiscoverImpression();
};

module.exports = {
    initDataLayer : initDataLayer
};
